<template>
  <svg :class="['icon-chevron', direction]" :stroke="stroke" xmlns="http://www.w3.org/2000/svg" width="11.073" height="11.073" viewBox="0 0 11.073 11.073"><path d="M639,45v6.78h6.879" transform="translate(-482.954 424.886) rotate(-45)" fill="none" stroke="#ffde01" stroke-width="2"/></svg>
</template>

<script>
export default {
  name: 'IconChevron',
  props: {
    direction: {
      type: String,
      default: 'down',
      validator (value) {
        return ['up', 'down', 'left', 'right'].includes(value)
      }
    },
    color: {
      type: String,
      default: 'dark'
    }
  },
  computed: {
    stroke () {
      if (this.color === 'light') {
        return '#FFFFFF'
      } else {
        return '#1C1C1C'
      }
    }
  }
}
</script>

<style>
.icon-chevron.up {
  transform: rotate(180deg);
}

.icon-chevron.down {
  transform: rotate(0deg);
}

.icon-chevron.left {
  transform: rotate(90deg);
}

.icon-chevron.right {
  transform: rotate(270deg);
}
</style>
